import { IonContent } from '@ionic/react';
import React from 'react';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { HARDCODED_CATEGORIES } from '../../constants';

import { ScreenAboutLookStyles } from './AboutLook.styles';

export const ScreenAboutLook: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'AboutLook',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const { refreshUser } = useAccount();

  const handleNextStep = (): void => {
    userService.createOrUpdate({
      categories: HARDCODED_CATEGORIES,
      onboarding_data: {
        first_categories: HARDCODED_CATEGORIES,
      },
    });
    refreshUser();
    wizard.nextStep();
  };

  return (
    <ScreenAboutLookStyles
      bgImage={
        <img
          src={
            'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai-man/bg-about-look.png'
          }
          alt="Chat Vibe"
        />
      }
    >
      <IonContent>
        <OwnAiTitle className="local-title">
          Wow, That Look? Impressive!
        </OwnAiTitle>
        <OnboardingSubtitle>
          You’ve nailed the appearance—seriously, great choice! Now, let’s dive
          into the personality. Ready to make them truly one of a kind?
        </OnboardingSubtitle>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </ScreenAboutLookStyles>
  );
};
